import React from "react";
import { Dialog,DialogPanel, Disclosure, DisclosurePanel, DisclosureButton, Transition } from '@headlessui/react';
import { Link } from "gatsby";
import {
  XMarkIcon,
} from '@heroicons/react/24/outline'
import {
	PhoneIcon
  } from '@heroicons/react/24/solid'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { LogoMobile } from '../../images/logo';
import CtaBtn from "../UIElements/CtaBtn";

function classNames(...classes) {
return classes.filter(Boolean).join(' ')
}

// const Logo = <svg xmlns="http://www.w3.org/2000/svg" width="209" height="56" viewBox="0 0 209 60" fill="none">
// 				<path fillRule="evenodd" clipRule="evenodd" d="M14.7906 32.6248H13.2209V25.8626C13.2209 24.8482 12.775 23.9407 11.2588 23.9407C10.5809 23.9407 9.92091 24.1364 9.36794 24.4567V32.6248H7.79821V18.6555H9.36794V23.5314C9.95659 23.1755 10.7236 22.9441 11.5798 22.9441C14.0058 22.9441 14.7906 24.4211 14.7906 25.8092V32.6248ZM6.81406 21.4849H4.22757V32.6248H2.58649V21.4849H0V20.3816H6.81406V21.4849ZM17.4874 28.4429L23.5344 27.5531V27.3752C23.5344 24.35 22.1609 22.8552 19.8598 22.8552C17.416 22.8552 15.9712 24.7948 15.9712 27.8023C15.9712 30.9165 17.5409 32.8028 20.2879 32.8028C21.4117 32.8028 22.5176 32.518 23.1955 32.1265L22.7852 31.1122C22.2501 31.4325 21.3225 31.6817 20.4485 31.6817C18.629 31.6817 17.6301 30.4182 17.4874 28.4429ZM19.8241 23.8339C21.3225 23.8339 21.9825 24.9372 22.0182 26.8769L17.416 27.5887V27.4997C17.416 25.3287 18.2366 23.8339 19.8241 23.8339ZM33.9354 42.581H30.613V59.6474H27.5026V42.581H25.3112V40.6416H27.5026V37.9618C27.5026 34.3651 29.4819 31.9321 33.2992 31.9321C33.5113 31.9321 33.5466 31.9321 33.9354 31.9674V33.9773H33.7234C32.0621 33.9773 30.613 34.8235 30.613 37.856V40.6416H33.9354V42.581ZM2.2925 59.6474H5.54427V35.3877H2.2925V59.6474ZM20.0519 59.6474H23.1623V46.5302C23.1623 42.5105 20.9002 40.289 15.7751 40.289C13.407 40.289 11.0742 40.8179 9.3069 41.6289V59.6474H12.4173V42.8983C13.407 42.4752 14.4673 42.2636 15.7751 42.2636C18.8855 42.2636 20.0519 43.6741 20.0519 46.5302V59.6474ZM42.2524 60C47.4128 60 49.7809 55.8392 49.7809 50.1269C49.7809 44.4498 47.4128 40.289 42.2524 40.289C37.092 40.289 34.7238 44.4498 34.7238 50.1269C34.7238 55.8392 37.092 60 42.2524 60ZM42.2524 42.2636C45.5748 42.2636 46.6706 45.825 46.6706 50.0564C46.6706 54.2877 45.5748 57.9196 42.2524 57.9196C38.9299 57.9196 37.8342 54.2877 37.8342 50.0564C37.8342 45.825 38.9299 42.2636 42.2524 42.2636ZM60.6626 40.3948L59.9557 42.722C59.3902 42.5105 58.7186 42.4047 58.0117 42.4047C57.1634 42.4047 56.2798 42.5457 55.6082 42.8983V59.6474H52.4978V41.6289C54.1237 40.8179 56.2798 40.289 59.0014 40.289C59.7083 40.289 60.4859 40.3595 60.6626 40.3948ZM83.6995 59.6474H86.7746V46.4245C86.7746 42.7926 84.7245 40.289 80.059 40.289C77.7969 40.289 75.8529 41.1353 74.5804 42.5105C73.3433 41.0648 71.7174 40.289 68.8545 40.289C66.2743 40.289 64.1535 40.8179 62.3156 41.6289V59.6474H65.3906V42.8983C66.451 42.4399 67.5113 42.2636 68.9605 42.2636C71.7881 42.2636 72.9899 43.7093 72.9899 45.8955V59.6474H76.0649V44.062C76.9839 42.9689 78.221 42.2636 79.7762 42.2636C82.5685 42.2636 83.6995 43.8857 83.6995 46.3892V59.6474ZM102.838 58.6601C101.319 59.4711 99.0565 60 96.5117 60C91.9521 60 89.2659 58.0254 89.2659 54.2524C89.2659 49.6685 93.7901 47.9054 99.9402 47.306V46.1424C99.9402 43.533 98.5264 42.3694 95.8755 42.3694C94.2142 42.3694 92.4116 42.8631 91.1038 43.5683L90.3616 41.6642C91.9521 40.8532 94.1082 40.289 96.1582 40.289C100.294 40.289 102.838 42.2284 102.838 46.4597V58.6601ZM99.9402 57.567V48.928C95.0979 49.4922 92.2349 50.8321 92.2349 54.1819C92.2349 56.756 93.8254 58.2017 96.7944 58.2017C97.9962 58.2017 99.1979 57.9549 99.9402 57.567ZM111.664 59.8237C112.406 59.8237 113.042 59.7179 113.537 59.5063V57.5317C113.254 57.6375 112.936 57.6728 112.583 57.6728C111.028 57.6728 110.215 56.6855 110.215 55.0282V42.581H113.537V40.6416H110.215V35.3172L107.104 36.2692V40.6416H104.913V42.581H107.104V55.0282C107.104 58.1664 108.942 59.8237 111.664 59.8237ZM119.468 35.2819C119.468 36.234 118.619 37.0097 117.594 37.0097C116.569 37.0097 115.721 36.234 115.721 35.2819C115.721 34.3299 116.569 33.5541 117.594 33.5541C118.619 33.5541 119.468 34.3299 119.468 35.2819ZM116.039 59.6474V40.6416H119.15V59.6474H116.039ZM129.601 60C134.761 60 137.129 55.8392 137.129 50.1269C137.129 44.4498 134.761 40.289 129.601 40.289C124.44 40.289 122.072 44.4498 122.072 50.1269C122.072 55.8392 124.44 60 129.601 60ZM129.601 42.2636C132.923 42.2636 134.019 45.825 134.019 50.0564C134.019 54.2877 132.923 57.9196 129.601 57.9196C126.278 57.9196 125.183 54.2877 125.183 50.0564C125.183 45.825 126.278 42.2636 129.601 42.2636ZM153.702 59.6474H150.591V46.5302C150.591 43.6741 149.425 42.2636 146.314 42.2636C145.007 42.2636 143.946 42.4752 142.957 42.8983V59.6474H139.846V41.6289C141.613 40.8179 143.946 40.289 146.314 40.289C151.439 40.289 153.702 42.5105 153.702 46.5302V59.6474ZM165.668 59.6474H176.236V57.4612H168.919V35.3877H165.668V59.6474ZM191.203 58.6601C189.683 59.4711 187.421 60 184.876 60C180.316 60 177.63 58.0254 177.63 54.2524C177.63 49.6685 182.154 47.9054 188.304 47.306V46.1424C188.304 43.533 186.891 42.3694 184.24 42.3694C182.579 42.3694 180.776 42.8631 179.468 43.5683L178.726 41.6642C180.316 40.8532 182.472 40.289 184.523 40.289C188.658 40.289 191.203 42.2284 191.203 46.4597V58.6601ZM188.304 57.567V48.928C183.462 49.4922 180.599 50.8321 180.599 54.1819C180.599 56.756 182.19 58.2017 185.159 58.2017C186.36 58.2017 187.562 57.9549 188.304 57.567ZM200.305 60C205.996 60 209 55.9097 209 49.7743C209 44.0267 205.996 40.3595 201.542 40.3595C200.128 40.3595 198.821 40.6416 197.725 41.2058V31.9674H194.65V58.6601C195.922 59.4006 198.043 60 200.305 60ZM200.765 42.2284C204.052 42.2284 205.89 45.1903 205.89 49.9506C205.89 54.7108 204.334 58.0254 200.411 58.0254C199.457 58.0254 198.432 57.8491 197.725 57.5317V42.9336C198.608 42.5105 199.633 42.2284 200.765 42.2284Z" fill="white"/>
// 				<ellipse cx="127.303" cy="32.2953" rx="4.95496" ry="4.94315" fill="#86A8B8"/>
// 				<ellipse cx="140.021" cy="21.9146" rx="8.42343" ry="8.40336" fill="#7683A6"/>
// 				<ellipse cx="123.669" cy="9.88631" rx="9.90992" ry="9.88631" fill="#3797D3"/>
// 				<ellipse cx="117.723" cy="26.0339" rx="4.62463" ry="4.61361" fill="#E48D4E"/>
// 			</svg>

export default function MobileMenu({mobileMenuOpen, setMobileMenuOpen, mainMenu}) {
	return (
		<Dialog as="div" className="xl:hidden" open={mobileMenuOpen} onClose={setMobileMenuOpen}>
        <div className="fixed inset-0 z-50" />
        <DialogPanel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-global-900/90 p-6 pt-[3px] sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="-m-1.5 p-1.5">
              <span className="sr-only">The Information Lab</span>
              {LogoMobile}
            </Link>
            <button
              type="button"
              className="-m-2.5 cursor-pointer rounded-md p-2.5 text-white"
              onClick={() => setMobileMenuOpen(false)}
            >
              <span className="sr-only">Close menu</span>
              <XMarkIcon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <div className="mt-6 flow-root">
            <div className="-my-6 divide-y divide-gray-500/10">
              <div className="pt-6 pb-4">
                <div className="text-white font-title text-sm">
                  {mainMenu?.map(({node}) => {
                    if (node.Links && node.Links.length > 0) {
                      return (
                        <Disclosure as="div" className="-mx-3 mb-7" key={node.id}>
                          {({ open }) => {
                            return (
                            <>
                              <DisclosureButton className="flex w-full items-center cursor-pointer justify-between rounded-lg py-2 pl-3 pr-3.5 text-sm font-semibold leading-7 text-center uppercase hover:bg-global-700">
                              {node.Section}
                                <ChevronDownIcon
                                  className={classNames(open ? 'rotate-180' : '', 'h-5 w-5 flex-none transition duration-100')}
                                  aria-hidden="true"
                                />
                              </DisclosureButton>
                              <Transition
                                show={open}
                                enter="transition duration-100 ease-out origin-top"
                                enterFrom="transform scale-y-50 opacity-0"
                                enterTo="transform scale-y-100 opacity-100"
                                leave="transition duration-75 ease-out origin-top"
                                leaveFrom="transform scale-y-100 opacity-100"
                                leaveTo="transform scale-y-50 opacity-0"
                              >
                                <DisclosurePanel className="mt-2 space-y-2">
                                
                                      <Link
                                        to={node.InternalLink}
                                        className="block rounded-lg py-2 pl-6 pr-3 text-sm font-semibold leading-7 hover:bg-global-700 uppercase"
                                      >
                                        Overview
                                      </Link>
                                      {node.Links.map((item) => {
                                        if (item.InternalLink) {
                                          return (
                                            <Link
                                              key={item.id}
                                              to={item.InternalLink}
                                              className="block rounded-lg py-2 pl-6 pr-3 text-sm font-semibold leading-7 hover:bg-global-700 uppercase"
                                            >
                                              {item.Name}
                                            </Link>
                                          )
                                        }
                                        return (
                                          <Disclosure.Button
                                            key={item.id}
                                            as="a"
                                            href={item.ExternalLink}
                                            className="block rounded-lg py-2 pl-6 pr-3 text-sm font-semibold leading-7 hover:bg-global-700 uppercase"
                                          >
                                            {item.Name}
                                          </Disclosure.Button>
                                        )
                                        })}
                                </DisclosurePanel>
                              </Transition>
                            </>
                          )}}
                        </Disclosure>
                      )
                    }
                    if (node.InternalLink) {
                      return (
                        <Link
                          to={node.InternalLink}
                          className="-mx-3 mb-7 block rounded-lg px-3 py-2 text-sm font-semibold leading-7 hover:bg-global-700 uppercase"
                          key={node.id}
                        >
                          {node.Section}
                        </Link>
                      )
                    } else {
                      return (
                        <a
                          href={node.ExternalLink}
                          className="-mx-3 mb-7 block rounded-lg px-3 py-2 text-sm font-semibold leading-7 hover:bg-global-700 uppercase"
                          key={node.id}
                        >
                          {node.Section}
                        </a>
                      )
                    }
                    
                    } )}
                </div>
              </div>
              <div className="text-plum-900 space-y-6 uppercase text-sm font-semibold">
                    <div>
                      <Link to={'/privacy'}>
                        Privacy Policy
                      </Link>
                    </div>
                    <div>
                      <Link to={'/terms'}>
                        Terms of Use
                      </Link>
                    </div>
                    <div>
                      <Link to={'/cookies'}>
                        Cookie Policy
                      </Link>
                    </div>
              </div>
              <CtaBtn 
                label={<div className='flex py-1 uppercase text-white font-title font-semibold text-[12px]'><PhoneIcon className='w-4'/> +44 (0) 8453 888 289</div>} 
                colour={'blue'}
                className='mt-12'
                href='tel:+448453888289'
              />
              <CtaBtn 
                label={
                  <div className="flex text-xs">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="12" viewBox="0 0 18 12" fill="none" className="mt-[2px] mr-2">
                          <path d="M0.996202 0C0.676254 0 0.416656 0.26876 0.416656 0.6V11.4C0.416656 11.7312 0.676254 12 0.996202 12H16.8371C17.1571 12 17.4167 11.7312 17.4167 11.4V0.6C17.4167 0.26876 17.1571 0 16.8371 0H0.996202ZM2.63825 1.2H15.1951L8.91666 6.4312L2.63825 1.2ZM1.57575 1.85L8.55444 7.6624C8.7665 7.8374 9.06682 7.8374 9.27887 7.6624L16.2576 1.85V10.8H1.57575V1.85Z" fill="white"/>
                      </svg>
                      INFO@THEINFORMATIONLAB.CO.UK
                  </div>
                  } 
                colour={'blue'}
                className='mt-4'
                href='mailto:info@theinformationlab.co.uk'
              />
            </div>
          </div>
        </DialogPanel>
      </Dialog>
	)
}